<template>
    <form :action="route('jobs-progress.index')" method="get">
        <input type="hidden" name="filtered" value="true"/>
        <div class="row d-flex">
            <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                <app-select
                    label="Status"
                    :error="this.statusError"
                    placeholder="Status"
                    name="status"
                    id="filter-statuses"
                    :is-multiple="false"
                    :use-search="false"
                    :options="this.statusOptions"
                    :value="this.statusValue"
                ></app-select>
            </div>
            <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                <app-select
                    label="Connection Type"
                    :error="this.typeError"
                    placeholder="Connection Type"
                    name="type"
                    id="filter-type"
                    :is-multiple="false"
                    :use-search="false"
                    :options="this.typeOptions"
                    :value="this.typeValue"
                ></app-select>
            </div>
            <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                <app-select
                    label="Sub Connection Type"
                    :error="this.subTypeError"
                    placeholder="Sub Connection Type"
                    name="sub_type"
                    id="filter-sub-type"
                    :is-multiple="false"
                    :use-search="false"
                    :options="this.subTypeOptions"
                    :value="this.subTypeValue"
                ></app-select>
            </div>
            <button-set class="col-md-auto col-12 p-md-0 mb-3 mb-md-0 mt-4_5">
                <app-button type="primary" :link="route('jobs-progress.index')" submit="submit">
                    <ion-icon name="search-outline"></ion-icon>
                    Search
                </app-button>
                <app-button type="light" @click="toggleAdvanced">
                    <ion-icon v-if="advancedSearch" name="caret-up-outline"></ion-icon>
                    <ion-icon v-else name="caret-down-outline"></ion-icon>
                    Advanced search
                </app-button>
            </button-set>
        </div>
        <slot v-if="advancedSearch"/>
    </form>
</template>
<script>
    export default {
        props: {
            initAdvancedSearch: {
                default: false
            },
            search: {
                type: String,
                default: ''
            },
            statusError: {
                type: String,
                default: ''
            },
            statusValue: {
                type: String,
                default: ''
            },
            statusOptions: {
                type: Array,
                default: []
            },
            typeError: {
                type: String,
                default: ''
            },
            typeValue: {
                type: String,
                default: ''
            },
            typeOptions: {
                type: Array,
                default: []
            },
            subTypeError: {
                type: String,
                default: ''
            },
            subTypeValue: {
                type: String,
                default: ''
            },
            subTypeOptions: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                advancedSearch: Boolean(this.initAdvancedSearch)
            }
        },
        methods: {
            toggleAdvanced() {
                this.advancedSearch = !this.advancedSearch;
            }
        }
    }
</script>
